import React, { } from "react";
import BrandComponents from "../Brand/BrandComponents";


function BranchTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Branch Name", field: "branchname" },
    { label: "Email", field: "email" },
    { label: "Phone No.", field: "phoneno" },
    { label: "Country Name", field: "countryname" },
    { label: "State Name", field: "statename" },
    { label: "City Name", field: "cityname" },



  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"BRANCH"}
        apiField={"branch"}
        addButton={"+ ADD"}
        createRoute={"/branchCreate"}
        updateRoute={"/BranchView"}
        viewRoute={"/branchView"}
      />
    </div>
  );
}

export default BranchTable;
